import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 自動判定基準 */
enum AutoJudgmentCriteria {
  leaseAccounting = '1',
  tax = '2',
  ifrs = '3',
}

const nameConfig = {
  leaseAccounting: new Map([
    [Locale.ja, 'リース会計'],
    [Locale.en, 'Lease Account'],
  ]),
  tax: new Map([
    [Locale.ja, '税務'],
    [Locale.en, 'Tax'],
  ]),
  ifrs: new Map([
    [Locale.ja, 'IFRS'],
    [Locale.en, 'IFRS'],
  ]),
};

const toEnum = rawValueToEnum(AutoJudgmentCriteria, AutoJudgmentCriteria.leaseAccounting);
const toDisplay = enumToName(AutoJudgmentCriteria, nameConfig);
const toDisplayWithPrefix = enumToName(AutoJudgmentCriteria, nameConfig, { prefix: true });

export const autoJudgmentCriteria = {
  enum: AutoJudgmentCriteria,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AutoJudgmentCriteria };
